import React from 'react'
import styled, {css, keyframes} from 'styled-components'
import Link from 'gatsby-link'
import to from "gatsby-link";
import presets from "../utils/presets"
import {rhythm} from "../utils/typography"

const radius =  rhythm(0.1)
const stripecolor = "#e1ff00"

const movebg = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 100px 0;
  }
`

const Cta = styled(Link)`
  display: inline-block;
  position:relative;
  ${'' /* box-sizing: border-box; */}
  padding: ${rhythm(0.4)} ${rhythm(0.5)};
  background-color: ${presets.brand};
  font-family: ${presets.brandFontFamily};
  text-transform: uppercase;
  line-height: 1;
  ::before{content:"";}
  ::after{content:"";}
  ${presets.shadowMed}
  :hover{
    ${presets.shadowLow}
    background-color: ${presets.brand};
  }
`

const Container = styled.div`
  position:relative;
  ${'' /* overflow:hidden; */}
  display:inline-block;

`
const Wrapper = styled.div`
  position:relative;
  ${'' /* overflow:hidden; */}
  display:block;
  ${'' /* padding:${rhythm(0.2)}; */}
  box-sizing: content-box;
`

const Stripes = styled.div`
  background-image: linear-gradient(
    ${props => props.bottom ? '-45deg' : '45deg'},
    ${stripecolor} 25%,
    transparent 25%,
    transparent 50%,
    ${stripecolor} 50%,
    ${stripecolor} 75%,
    transparent 75%,
    transparent
    );
  background-size: ${rhythm(0.5)} ${rhythm(0.5)};
  animation: ${movebg} 1.8s infinite linear forwards;
  animation-fill-mode: none;

  position:absolute;
  display:block;
  top:${props => props.bottom ? '50%' : '0'};
  left:100%;
  right:0;
  bottom:0;
  height:50%;
  width:${rhythm(0.5)};
  border-radius: 0 ${rhythm(0.5)} 0 0 ;

`



export default(props) => {
  return(
    <Container><Wrapper><Cta to={props.to}>{props.children}</Cta><Stripes /><Stripes bottom /></Wrapper></Container>
  );
}



// WEBPACK FOOTER //
// ./src/com/CtaAnimated.js